import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { GuestService } from '../services/guest.service';
import { DEFAULT_LANGUAGE_CODE, DEFAULT_LANGUAGE_ID } from '../constants/commonenums';
import { LanguageCode } from '../Models/WidgetSettingsModels';
import { getLanguageFromQueryParam, getLanguageFromRouteParam } from 'src/app/app-initializer';

@Pipe({
  name: 'localizeDate',
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(private gs: GuestService) {}

  transform(value: Date | string, formatDate = 'mediumDate'): string {
   // moment.locale(this.gs.availableLanguages.find(lng => lng.Id == sessionStorage.getItem('languageId'))?.Code || 'en')
   let localeValue = 'en';
   let localMoment = moment(value);
   let url = new URL(window.location.href);

   let language = getLanguageFromRouteParam(url) || getLanguageFromQueryParam(url); 
    if(language){
      localeValue = LanguageCode[language?.toLowerCase()]
         
    }
    else {
      localeValue = sessionStorage.getItem('languageCode') || localeValue;
    }

    if(localeValue == LanguageCode.chinesesimplified){
      localeValue = formatDate === 'dddd' ? "zh-cn" : localeValue;
      var time = localMoment?.locale(localeValue)?.format(formatDate);
      time = time?.replace(/AM/g, "上午").replace(/PM/g, "下午");
      return time;
    }

    if(localeValue == LanguageCode.chinesetraditional){
      localeValue = formatDate === 'dddd' ? "zh-tw" : localeValue;
      var time = localMoment?.locale(localeValue)?.format(formatDate);
      time = time?.replace(/AM/g, "上午").replace(/PM/g, "下午");
      return time;
    }
    
    return localMoment.locale(localeValue).format(formatDate);  
  
  }
}